<template>
  <div>
    <v-dialog v-model="localDialogView" max-width="500px">
      <TableDetail :editedItem="editedItem" @closeParent="$emit('close')" />
    </v-dialog>

    <v-dialog v-model="localDialog" max-width="600px">
      <TableEdit
        :editedItem="editedItem"
        :editedIndex="editedIndex"
        @closeParent="$emit('close')"
      />
    </v-dialog>

    <v-dialog v-model="localDialogDelete" max-width="500px" @click:outside="$emit('closeDelete')">
      <v-card>
        <v-card-title class="headline">
          Are you sure you want to delete this item?
        </v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1"  text @click="$emit('closeDelete')">Cancel</v-btn>
          <v-btn color="blue darken-1" :loading="loadingDelete" text @click="$emit('deleteItemConfirm')">OK</v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
  components: {
    TableEdit : () => import('./UserEdit.vue'),
    TableDetail: () => import('./UserDetail.vue')
  },
  props: {
    dialogView: {
      type: Boolean,
      default: false
    },
    dialog: {
      type: Boolean,
      default: false
    },
    dialogDelete: {
      type: Boolean,
      default: false
    },
    loadingDelete:{
      type: Boolean,
      default: false
    },
    editedItem: {
      type: Object,
      default: () => ({}),
    },
    editedIndex: {
      type: Number,
      default: -1,
    },
  },
  computed: {
    localDialogView: {
      get() {
        return this.dialogView;
      },
      set(value) {
        this.$emit('update:dialogView', value);
      }
    },
    localDialog: {
      get() {
        return this.dialog;
      },
      set(value) {
        this.$emit('update:dialog', value);
      }
    },
    localDialogDelete: {
      get() {
        return this.dialogDelete;
      },
      set(value) {
        this.$emit('update:dialogDelete', value);
      }
    }
  },
};
</script>
